import { JSXElement } from '@/common/types';
import { ProgressSpinner } from 'primereact/progressspinner';

export function Loading(): JSXElement {
    return <ProgressSpinner />;
}
